import { useQuery } from "@tanstack/react-query";
import { fetchNeedsReview, type NeedsReviewQuery } from "@/api/needsReview";

const STALE = 60 * 1000;

/** Phase 3.X-1B sub_3 — NeedsReview queue. */
export function useNeedsReview(query: NeedsReviewQuery) {
  return useQuery({
    queryKey: ["needsReview", query.cursor ?? "", query.scope ?? "", query.manager ?? ""],
    queryFn: ({ signal }) => fetchNeedsReview(query, signal),
    staleTime: STALE,
  });
}
